import { CustomFilterListItem, DateFilterListItem, DateFilterListItemKey } from '../constants';
import { Action, ActionType, State } from './types';

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case ActionType.ClearDate: {
      return {
        ...state,
        startTime: undefined,
        endTime: undefined,
        isCalendarOpen: false,
      };
    }
    case ActionType.ClearList: {
      return {
        ...state,
        selectedItem: undefined,
      };
    }
    case ActionType.DateListItemClick: {
      const { value } = action.payload;
      const isCustomOption = value.key === DateFilterListItemKey.Custom;

      if (isCustomOption) {
        return { ...state, selectedItem: value, isCalendarOpen: true };
      }

      return { ...state, startTime: new Date(), endTime: new Date(), selectedItem: value };
    }
    case ActionType.SetCalendar: {
      return {
        ...state,
        isCalendarOpen: action.payload.value,
      };
    }
    default: {
      return state;
    }
  }
}

export function getSelectedOption(
  selectedOption?: DateFilterListItem,
  startTime?: Date,
  endTime?: Date,
) {
  if (selectedOption) {
    return selectedOption;
  }
  if (startTime && endTime) {
    return CustomFilterListItem[0];
  }
  return undefined;
}
